function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { guid } from '@bydesign-ui/utils';
import { Emitter } from '@bydesign-ui/hooks';
export var Menu = function (_Emitter) {
  _inherits(Menu, _Emitter);

  var _super = _createSuper(Menu);

  function Menu(options) {
    var _this;

    _classCallCheck(this, Menu);

    _this = _super.call(this);
    _this.depth = 1;
    _this.insId = guid();
    _this.menuItemMap = {};
    _this.subMenuMap = {};
    _this.openIds = [];
    _this.type = 'inline';
    _this.trigger = 'hover';
    _this.activeId = '';
    _this.activeMenus = [];
    _this.collapse = false;
    _this.accordion = false;

    _this.updateMenuOptions(options);

    return _this;
  }

  _createClass(Menu, [{
    key: "updateMenuOptions",
    value: function updateMenuOptions(options) {
      var _options$type = options.type,
          type = _options$type === void 0 ? 'inline' : _options$type,
          _options$openIds = options.openIds,
          openIds = _options$openIds === void 0 ? [] : _options$openIds,
          _options$trigger = options.trigger,
          trigger = _options$trigger === void 0 ? 'hover' : _options$trigger,
          activeId = options.activeId,
          _options$collapse = options.collapse,
          collapse = _options$collapse === void 0 ? false : _options$collapse,
          _options$accordion = options.accordion,
          accordion = _options$accordion === void 0 ? false : _options$accordion,
          extraProps = options.extraProps;
      this.type = type;
      this.trigger = trigger;
      this.extraProps = extraProps;
      this.accordion = accordion;
      this.collapse = collapse;
      this.openIds = openIds.slice(0);

      if (activeId != null && this.activeId !== activeId) {
        this.activeId = activeId;
        this.emitActiveItemUpdate();
      }
    }
  }, {
    key: "getType",
    value: function getType() {
      return this.type;
    }
  }, {
    key: "getDepth",
    value: function getDepth() {
      return this.depth;
    }
  }, {
    key: "setDepth",
    value: function setDepth(depth) {
      if (depth > this.depth) {
        this.depth = depth;
      }
    }
  }, {
    key: "getInsId",
    value: function getInsId() {
      return this.insId;
    }
  }, {
    key: "getActiveId",
    value: function getActiveId() {
      return this.activeId;
    }
  }, {
    key: "getCollapse",
    value: function getCollapse() {
      return this.collapse;
    }
  }, {
    key: "getAccordion",
    value: function getAccordion() {
      return this.accordion;
    }
  }, {
    key: "setActiveMenus",
    value: function setActiveMenus(menuId) {
      if (menuId === null) {
        this.activeMenus = [];
      } else {
        this.activeMenus.push(menuId);
      }
    }
  }, {
    key: "getActiveMenus",
    value: function getActiveMenus() {
      return this.activeMenus;
    }
  }, {
    key: "isOpened",
    value: function isOpened(id) {
      return this.openIds.indexOf(id) >= 0;
    }
  }, {
    key: "getOpenIds",
    value: function getOpenIds() {
      return this.openIds;
    }
  }, {
    key: "setActiveItem",
    value: function setActiveItem(insId, id) {
      if (!this.menuItemMap[insId]) {
        throw new Error("insId=".concat(insId, " menu item dose not under current menu"));
      }

      var prevActiveId = this.activeId;
      this.activeId = id;
      this.emitActiveItemChange();

      if (this.activeId !== prevActiveId) {
        this.emitActiveItemUpdate();
      }
    }
  }, {
    key: "getExtraProps",
    value: function getExtraProps() {
      return this.extraProps || {};
    }
  }, {
    key: "getTrigger",
    value: function getTrigger() {
      return this.trigger;
    }
  }, {
    key: "emitOpenMenusChange",
    value: function emitOpenMenusChange() {
      this.emit('open-menus-change', this.openIds);
    }
  }, {
    key: "emitOpenMenusUpdate",
    value: function emitOpenMenusUpdate() {
      this.emit('open-menus-update');
    }
  }, {
    key: "emitActiveItemChange",
    value: function emitActiveItemChange() {
      this.emit('active-item-change', this.activeId);
    }
  }, {
    key: "emitActiveItemUpdate",
    value: function emitActiveItemUpdate() {
      this.emit('active-item-update', this.activeId);
    }
  }, {
    key: "setOpen",
    value: function setOpen(insId, id, open) {
      if (!this.subMenuMap[insId]) {
        throw new Error("SetOpen failed because insId=".concat(insId, " subMenu has not been registered in current menu"));
      }

      var openIds = this.openIds;
      var idx = openIds.indexOf(id);

      if (open && idx < 0) {
        openIds.push(id);
      } else if (!open && idx >= 0) {
        openIds.splice(idx, 1);
      }
    }
  }, {
    key: "setOpenIds",
    value: function setOpenIds(ids) {
      this.openIds = ids;
    }
  }, {
    key: "resetOpenIds",
    value: function resetOpenIds() {
      this.setOpenIds([]);
      this.emitOpenMenusUpdate();
    }
  }, {
    key: "registerMenuItem",
    value: function registerMenuItem(menu) {
      var id = menu.getInsId();

      if (this.menuItemMap[id]) {
        throw new Error("id=".concat(id, " menuItem has been registered"));
      }

      this.menuItemMap[id] = menu;
    }
  }, {
    key: "unregisterMenuItem",
    value: function unregisterMenuItem(menu) {
      var insId = menu.getInsId();

      if (!this.menuItemMap[insId]) {
        throw new Error("insId=".concat(insId, " menuItem has not been registered in current menu"));
      }

      delete this.menuItemMap[insId];
    }
  }, {
    key: "registerSubMenu",
    value: function registerSubMenu(subMenu) {
      var insId = subMenu.getInsId();

      if (this.subMenuMap[insId]) {
        throw new Error("insId=".concat(insId, " subMenu has been registered"));
      }

      this.subMenuMap[insId] = subMenu;
    }
  }, {
    key: "unregisterSubMenu",
    value: function unregisterSubMenu(subMenu) {
      var insId = subMenu.getInsId();

      if (!this.subMenuMap[insId]) {
        throw new Error("insId=".concat(insId, " subMenu has not been registered in current menu"));
      }

      delete this.subMenuMap[insId];
    }
  }]);

  return Menu;
}(Emitter);